import React, { useState, lazy } from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon, SparklesIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const CHECKOUT_URL = 'https://f13dpf-q0.myshopify.com/cart/47706120126618:1?channel=buy_button';
const UPSELL_CHECKOUT_URL = 'https://4sfaxb-5b.myshopify.com/cart/53494883942707:1?channel=buy_button';
export function PricingSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const included = ['Acceso de por vida al programa', 'Acceso a todos los BONOS', '+30 videos prácticos paso a paso', 'Acceso a la Comunidad de alumnos', 'Plantillas prácticas para aplicar', 'Garantía de 7 días'];
  const currentCheckout = UPSELL_CHECKOUT_URL;
  return <section id="compra" className="bg-gradient-to-b from-gray-900 to-black text-white py-8 md:py-12 px-4 bg-[#090202] mt-[0px] mb-[0px] pt-[60px] pb-[60px]" data-id="element-212">
      <div className="max-w-3xl mx-auto" data-id="element-213">
        {/* Header */}
        <div className="rounded-t-2xl px-6 py-8 text-center bg-[#16A34A] mt-[-20px] mb-[-20px]" data-id="element-214">
          <h2 className="text-2xl md:text-3xl font-black uppercase leading-tight mb-3" data-id="element-215">
            Accedé ahora y empezá a{' '}
            <span className="underline decoration-4 decoration-yellow-300" data-id="element-216">
              vender este fin de semana
            </span>
          </h2>
          <p className="text-base md:text-lg text-green-100 max-w-xl mx-auto" data-id="element-217">
            Estás a 1 Producto de cambiar tu vida.
          </p>
        </div>

        {/* Main Card */}
        <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-b-3xl p-6 md:p-10 shadow-2xl border-2 border-t-0 border-slate-600 bg-[#444040]" data-id="element-218">
          {/* Product Title & Includes */}
          <div className="text-center mb-6" data-id="element-219">
            <h3 className="text-3xl md:text-4xl font-black text-slate-200 mb-2 tracking-wide" data-id="element-220">
              DOMINANDO SHOPIFY💰
            </h3>
            <p className="text-xl text-white mb-6 font-[500]" data-id="element-221">Resúmen</p>

            <div className="text-left max-w-md mx-auto space-y-3 mb-8" data-id="element-222">
              {included.map((item, index) => <div key={index} className="flex items-center gap-3" data-id="element-223">
                  <span className="w-3 h-3 bg-green-500 rounded-full flex-shrink-0" data-id="element-224"></span>
                  <span className="text-base md:text-lg text-slate-200 font-medium" data-id="element-225">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Selection Instruction */}
          <div className="text-center mb-6" data-id="element-226">
            <p className="text-base text-slate-300" data-id="element-227">
              👇 Elegí la opción que más se adapte a vos y luego dale click al
              botón de abajo:
            </p>
          </div>

          {/* Plan Options */}
          <div className="space-y-4 mb-8" data-id="element-228">
            {/* Premium Plan - $49.990 */}
            <div className="relative rounded-2xl p-5 md:p-6 border-2 border-green-400 bg-slate-700/80 shadow-[0_0_20px_rgba(34,197,94,0.2)]" data-id="element-229">
              {/* Badge */}
              <div className="absolute -top-3 left-4" data-id="element-230">
                <span className="inline-flex items-center gap-1.5 bg-green-500 text-white text-xs font-black uppercase tracking-wider px-4 py-1.5 rounded-full shadow-lg" data-id="element-231">
                  Acceso Completo ⭐⭐⭐⭐⭐
                </span>
              </div>

              <div className="flex items-center justify-between mt-2" data-id="element-232">
                <div data-id="element-233">
                  <p className="text-lg font-bold text-white mb-1" data-id="element-234">
                    Programa + 5 BONUS + Consultoría grupal ⭐
                  </p>
                  <p className="text-sm text-red-400 font-bold line-through mb-1" data-id="element-235">
                    Antes $99.990
                  </p>
                  <p className="text-3xl md:text-4xl font-black text-green-400" data-id="element-236">
                    $49.990
                  </p>
                  <p className="text-sm text-green-300 font-semibold mt-1" data-id="element-237">
                    Incluye 4 consultorías grupales en vivo
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center" data-id="element-238">
            <motion.div animate={{
            scale: [1, 1.03, 1]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-239">
              <CTAButton text="ACCEDER CON CONSULTORÍA $49.990 →" href={currentCheckout} size="large" className="!bg-green-500 hover:!bg-green-400 !text-white font-black text-lg md:text-xl w-full shadow-[0_0_30px_rgba(34,197,94,0.4)] hover:shadow-[0_0_40px_rgba(34,197,94,0.6)]" data-id="element-240" />
            </motion.div>

            <div className="mt-4 inline-block bg-green-500/10 px-4 py-1.5 rounded-full border border-green-500/30 animate-pulse" data-id="element-241">
              <p className="text-sm md:text-base text-green-400 font-black tracking-wide" data-id="element-242">
                💳 En hasta 3 cuotas{' '}
                <span className="underline decoration-2 underline-offset-4" data-id="element-243">
                  SIN INTERÉS
                </span>
              </p>
            </div>

            <div className="mt-4 flex flex-col items-center gap-3" data-id="element-244">
              <img src="https://cdn.magicpatterns.com/uploads/atARmzfGK6cg37j9MinZG9/logo_mercado_pago.png" alt="Mercado Pago" loading="lazy" className="h-14 object-contain bg-white rounded-lg px-4 py-2" data-id="element-245" />
              <p className="text-sm text-slate-400 font-semibold" data-id="element-246">
                🔒 Compra verificada y protegida por MercadoPago
              </p>
            </div>
          </div>
        </div>

        <div className="bg-blue-900 bg-opacity-50 border-2 border-blue-400 rounded-2xl p-8 text-center pt-[20px] pb-[20px] mt-[25px] mb-[25px]" data-id="element-247">
          <img src="https://cdn.magicpatterns.com/uploads/uJUkiYW4VEvaYTb76LJCEm/Historias_Destacadas_(1).png" alt="Garantía 7 días - 100% de satisfacción" loading="lazy" className="w-32 h-32 md:w-40 md:h-40 object-contain mx-auto mb-4" data-id="element-248" />
          <h4 className="text-2xl font-bold mb-4" data-id="element-249">
            ✓ Garantía de 7 días sin vueltas
          </h4>
          <p className="text-lg text-gray-300" data-id="element-250">
            Queremos que entres con tranquilidad. Si accedés al programa y
            sentís que no era para vos, podés pedir la devolución. Sin preguntas
            ni vueltas.
          </p>
        </div>

        {/* WhatsApp Dudas */}
        <div className="mt-8 text-center" data-id="element-251">
          <h4 className="text-xl md:text-2xl font-bold text-white mb-4" data-id="element-252">
            ¿Dudas? hacé clic acá abajo.
          </h4>
          <a href="https://wa.me/5491138726992?text=Hola%2C%20mi%20nombre%20es%20........%20y%20quiero%20ingresar%20al%20programa%20DOMINANDO%20SHOPIFY%20y%20activar%20mi%20m%C3%A1quina%20de%20ventas%20100%25%20en%20autom%C3%A1tico%20hoy%20mismo.%20Quiero%20saber%20c%C3%B3mo......" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#20bd5a] text-white font-bold text-lg md:text-xl px-8 py-4 rounded-full transition-all duration-200 hover:scale-105 shadow-[0_0_20px_rgba(37,211,102,0.4)]" data-id="element-253">
            <svg viewBox="0 0 24 24" className="w-7 h-7 fill-current" xmlns="http://www.w3.org/2000/svg" data-id="element-254">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-255" />
            </svg>
            Escribinos por WhatsApp
          </a>
        </div>

        {/* ¿Cuánto cuesta NO tenerlo? */}
        <div className="mt-10 rounded-2xl border-2 border-purple-500/50 overflow-hidden bg-[#0A0D16]" data-id="element-256">
          <div className="text-center py-8 px-4" data-id="element-257">
            <h3 className="text-2xl md:text-4xl font-black text-white uppercase" data-id="element-258">
              ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
            </h3>
          </div>

          {/* Table */}
          <div className="mx-4 mb-6 rounded-xl overflow-hidden border border-purple-500/30" data-id="element-259">
            {/* Header */}
            <div className="grid grid-cols-2" data-id="element-260">
              <div className="bg-[#1a1a2e] px-4 py-4 md:px-6 md:py-5 border-r border-purple-500/30" data-id="element-261">
                <p className="text-white font-bold text-sm md:text-lg text-center" data-id="element-262">
                  Sin Dominando Shopify
                </p>
              </div>
              <div className="bg-[#1a1a2e] px-4 py-4 md:px-6 md:py-5" data-id="element-263">
                <p className="text-[#FC9DFF] font-bold text-sm md:text-lg text-center" data-id="element-264">
                  Costo real
                </p>
              </div>
            </div>

            {/* Rows */}
            {[{
            sin: 'Meses buscando info gratis en YouTube',
            costo: '+200 horas perdidas sin resultados'
          }, {
            sin: 'Probar sin método ni estrategia',
            costo: 'Dinero tirado en publicidad sin retorno'
          }, {
            sin: 'No saber elegir un nicho rentable',
            costo: 'Productos que nadie compra — frustración'
          }, {
            sin: 'Crear tu tienda sin guía profesional',
            costo: 'Tienda que no convierte — $0 en ventas'
          }, {
            sin: 'Sin acompañamiento ni soporte',
            costo: 'Te trabás y abandonás — volvés al punto cero'
          }, {
            sin: 'Miedo a invertir en publicidad',
            costo: 'Seguís en el mismo trabajo que no te llena'
          }, {
            sin: 'Esperar "el momento perfecto"',
            costo: 'El mismo ciclo — el próximo año igual'
          }].map((row, index) => <div key={index} className={`grid grid-cols-2 ${index % 2 === 0 ? 'bg-[#12121f]' : 'bg-[#0e0e1a]'}`} data-id="element-265">
                <div className="px-4 py-4 md:px-6 md:py-5 border-r border-purple-500/20" data-id="element-266">
                  <p className="text-gray-300 text-xs md:text-base" data-id="element-267">
                    {row.sin}
                  </p>
                </div>
                <div className="px-4 py-4 md:px-6 md:py-5" data-id="element-268">
                  <p className="text-white font-bold text-xs md:text-base" data-id="element-269">
                    {row.costo}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        {/* Mental Triggers */}
        <div className="grid md:grid-cols-2 gap-6 mt-8" data-id="element-270">
          <div className="rounded-xl p-6 border border-gray-800 flex items-start gap-4 bg-[#0A0D16]" data-id="element-271">
            <div className="bg-green-500/20 p-3 rounded-lg text-green-500 shrink-0" data-id="element-272">
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-273">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-274" />
              </svg>
            </div>
            <div data-id="element-275">
              <h3 className="text-white font-bold text-lg mb-2" data-id="element-276">
                Retorno Inmediato
              </h3>
              <p className="text-gray-400" data-id="element-277">
                Recuperás la inversión con tu primera venta. El riesgo es 0.
              </p>
            </div>
          </div>

          <div className="bg-gray-900/50 rounded-xl p-6 border border-gray-800 flex items-start gap-4" data-id="element-278">
            <div className="bg-yellow-500/20 p-3 rounded-lg text-yellow-500 shrink-0" data-id="element-279">
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-280">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" data-id="element-281" />
              </svg>
            </div>
            <div data-id="element-282">
              <h3 className="text-white font-bold text-lg mb-2" data-id="element-283">
                Acción Rápida
              </h3>
              <p className="text-gray-400" data-id="element-284">
                Los BONUS y el valor especial están por terminar!!
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mt-8" data-id="element-285">
          <CTAButton text="QUIERO ASEGURAR MI LUGAR AHORA 👉🏻" onClick={scrollToCompra} size="large" className="!bg-red-600 hover:!bg-red-500 !text-white shadow-[0_0_30px_rgba(220,38,38,0.5)] hover:shadow-[0_0_50px_rgba(220,38,38,0.7)] w-full md:w-auto" data-id="element-286" />
          <p className="text-gray-400 mt-4 text-sm font-medium" data-id="element-287">
            🔒 Pago 100% seguro y garantizado
          </p>
        </div>
      </div>
    </section>;
}